import React from 'react';
import { Image } from 'lucide-react';

interface SiteImagesModuleProps {
  siteId: string;
}

const PLACEHOLDER_LABELS = [
  'INV-07', 'Array B', 'Substation',
  'Thermal', 'Panel Crack', 'Fence Line',
];

const SiteImagesModule: React.FC<SiteImagesModuleProps> = () => {
  return (
    <div className="space-y-3">
      {/* Photo grid */}
      <div className="grid grid-cols-3 gap-2">
        {PLACEHOLDER_LABELS.map((label, i) => (
          <div
            key={i}
            className="aspect-square rounded-lg flex items-center justify-center cursor-pointer transition-colors hover:opacity-80"
            style={{
              backgroundColor: 'var(--color-bg-tertiary)',
              border: '1px solid var(--color-border)',
            }}
          >
            <div className="text-center">
              <Image className="w-4 h-4 mx-auto" style={{ color: 'var(--color-text-muted)' }} />
              <span className="text-[10px] mt-1 block" style={{ color: 'var(--color-text-muted)' }}>
                {label}
              </span>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
        12 photos &middot; Latest: 3d ago
      </p>
    </div>
  );
};

export default SiteImagesModule;
